// GENERATED FILE - DO NOT MODIFY
export enum ProcoreSynchronizationDirection {
    ToMaestro = 0,
    ToProcore = 1,
    Both = 2,
    None = 3,
}

export let nameof = "ProcoreSynchronizationDirection";
